<template>
	<div class="bookshelfIndexBox">
		<!-- dark_horse_list -->
		<!-- 黑马榜 -->
		<div class="yunjin_jbBox">
			<div class="title_house">
				<div>
					<h4>黑马榜</h4>
				</div>
				<div @click.stop="toSoltDetail(11)">
					<span>全部</span>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
			</div>
			<div class="yunjin_jb" v-if="showdark_horse_list">
				<swiper class="swiper" :options="sj_swiperOption">
					<swiper-slide v-for="(dark_horse_list,index) in dark_horse_list">
						<div @click="jumpBookinfo(dark_horse_list.book_id,dark_horse_list.lock_status)">
							<div>
								<img :src="$api.$BASE_URL_img + dark_horse_list.cover_image" alt="">
							</div>
							<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in dark_horse_list.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
							<p class="jianjie"><span v-for="(books_name,bookNameIndex) in dark_horse_list.introduce" v-if="bookNameIndex > 7 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>

					<swiper-slide v-if="dark_horse_list.length>0">
						<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"
						 @click.stop="toSoltDetail(11)" />
					</swiper-slide>
				</swiper>
			</div>
			<div v-show="!showdark_horse_list" class="zwsjToast">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 最近阅读  -- 封面-->
		<div class="yunjin_jbBox" v-if="!showBoxFm">
			<div class="title_house">
				<div>
					<h4>最近阅读</h4>
				</div>
				<div @click.stop="toSoltDetail(13)">
					<span>全部</span>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
			</div>
			<div class="yunjin_jb" v-show="!showcollect_listFm">
				<swiper class="swiper" :options="hm_swiperOption">
					<swiper-slide v-for="(read_history,index) in read_history">
						<div @touchstart="gotouchstart01(read_history.id,read_history.books_id,read_history.lock_status,'阅读')" @touchmove="gotouchmove01"
						 @touchend="gotouchend01(read_history.id,read_history.books_id,read_history.lock_status,'阅读')" @click="jumpReadBook(read_history,read_history.lock_status)">
							<div class="bookImg" v-if="read_history.books_id != null">
								<img :src="$api.$BASE_URL_img + read_history.cover_image" alt="">
								<span v-if="read_history.progress_status == 1 ? true : false" class="bookState active_updata">{{read_history.progress_status_name}}</span>
								<span v-if="read_history.progress_status == 2 ? true : false" class="bookState active_wj">{{read_history.progress_status_name}}</span>
								<span v-if="read_history.progress_status == 0 ? true : false" class="bookState active_qj">{{read_history.progress_status_name}}</span>
							</div>
							<p class="bookName"><span v-for="(books_name,bookNameIndex) in read_history.books_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>
					<swiper-slide v-if="read_history.length>0">
						<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"
						 @click.stop="toSoltDetail(13)" />
					</swiper-slide>
				</swiper>
			</div>
			<div v-show="!showread_history" class="zwsjToast" style="margin-top:-120px;">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>

		<!-- 最近阅读  -- 列表 -->
		<div class="yunjin_jbBoxFm" v-if="showBoxFm">
			<div class="yunjin_jb" v-show="showcollect_listFm">
				<div v-for="(read_history,index) in read_historyFm" class="swiperFmImgFather" v-if="index == 0 ?true:false">
					<div v-for="(fmitm,fmidx) in read_history" class="swiperFmImg bookImg" @click="jumpReadBook(fmitm,fmitm.lock_status)"
					 v-if="fmitm.books_id != null">
						<img :src="$api.$BASE_URL_img + fmitm.cover_image" alt="">
						<span v-if="fmitm.progress_status == 1 ? true : false" class="bookState active_updata">{{fmitm.progress_status_name}}</span>
						<span v-if="fmitm.progress_status == 2 ? true : false" class="bookState active_wj">{{fmitm.progress_status_name}}</span>
						<span v-if="fmitm.progress_status == 0 ? true : false" class="bookState active_qj">{{fmitm.progress_status_name}}</span>
					</div>
				</div>
				<div class="totalBook">
					<p>最近阅读</p>
					<p>共{{read_history.length}}</p>
				</div>
				<img src="../../assets/img/rightarr_pink.png" alt="" class="yjjbArr02" @click.stop="toSoltDetail(13)" />
			</div>
		</div>
		<!-- 我的收藏 封面-->
		<div class="yunjin_jbBox yunjin_jbBoxFm_two" v-for="(itm,idx) in collect_list">
			<div class="title_house">
				<div>
					<h4>{{itm.name}}</h4>
				</div>
				<div @click.stop="toSoltDetail(12)">
					<span>全部</span>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
			</div>
			<div class="yunjin_jb" v-show="!showcollect_listFm">
				<swiper class="swiper" :options="sj_swiperOption">
					<swiper-slide v-for="(item,index) in itm.list" v-if="wj_show == true && item.progress_status == 2">
						<!-- jumpBookinfo(item.book_id,item.lock_status) -->
						<div @touchstart="gotouchstart(item.id,item.books_id,item.lock_status,'收藏')" @touchmove="gotouchmove" @touchend="gotouchend(item.id,item.books_id,item.lock_status,'收藏')"
						 @click="jumpReadBook(item,item.lock_status)" v-if="item.books_id != null">
							<div class="bookImg" v-if="item.books_id != null">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" v-if="item.books_id != null">
								<span v-if="item.progress_status == 1 ? true : false" class="bookState active_updata">{{item.progress_status_name}}</span>
								<span v-if="item.progress_status == 2 ? true : false" class="bookState active_wj">{{item.progress_status_name}}</span>
								<span v-if="item.progress_status == 0 ? true : false" class="bookState active_qj">{{item.progress_status_name}}</span>
							</div>
							<p class="bookName"><span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>
					<swiper-slide v-for="(item,index) in itm.list" v-if="wj_show == false && item.books_id != null">
						<!-- jumpBookinfo(item.book_id,item.lock_status) -->
						<div @touchstart="gotouchstart(item.id,item.books_id,item.lock_status,'收藏')" @touchmove="gotouchmove" @touchend="gotouchend(item.id,item.books_id,item.lock_status,'收藏')"
						 @click="jumpReadBook(item,item.lock_status)">
							<div class="bookImg" v-if="item.books_id != null">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" v-if="item.books_id != null">
								<span v-if="item.progress_status == 1 ? true : false" class="bookState active_updata">{{item.progress_status_name}}</span>
								<span v-if="item.progress_status == 2 ? true : false" class="bookState active_wj">{{item.progress_status_name}}</span>
								<span v-if="item.progress_status == 0 ? true : false" class="bookState active_qj">{{item.progress_status_name}}</span>
							</div>
							<p class="bookName"><span v-for="(books_name,bookNameIndex) in item.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>
					<swiper-slide v-if="itm.list.length>0">
						<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"
						 @click.stop="toSoltDetail(12)" />
					</swiper-slide>
				</swiper>
			</div>
			<div v-show="!showcollect_list" class="zwsjToast" style="margin-top:-120px;">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!--我的收藏 列表模式 -->
		<div v-for="(itm,idx) in collect_listFm">
			<div class="yunjin_jbBoxFm yunjin_jbBoxFm_two" v-if="showBoxFm  && scListShow == true" v-for="(itemFm,idnx) in itm">
				<div class="yunjin_jb" v-show="showcollect_listFm">
					<div class="swiperFmImgFather" v-if="idnx == 0 ?true:false">
						<div v-for="(fmitm,fmidx) in itemFm.list" @click="jumpReadBook(fmitm,fmitm.lock_status)" class="swiperFmImg" v-if="wj_show == true && fmitm.progress_status == 2">
							<img :src="$api.$BASE_URL_img + fmitm.cover_image" alt="">
							<span v-if="fmitm.progress_status == 1 ? true : false" class="bookState active_updata">{{fmitm.progress_status_name}}</span>
							<span v-if="fmitm.progress_status == 2 ? true : false" class="bookState active_wj">{{fmitm.progress_status_name}}</span>
							<span v-if="fmitm.progress_status == 0 ? true : false" class="bookState active_qj">{{fmitm.progress_status_name}}</span>
						</div>
						<div v-for="(fmitm,fmidx) in itemFm.list" @click="jumpReadBook(fmitm,fmitm.lock_status)" class="swiperFmImg" v-if="wj_show == false">
							<img :src="$api.$BASE_URL_img + fmitm.cover_image" alt="">
							<span v-if="fmitm.progress_status == 1 ? true : false" class="bookState active_updata">{{fmitm.progress_status_name}}</span>
							<span v-if="fmitm.progress_status == 2 ? true : false" class="bookState active_wj">{{fmitm.progress_status_name}}</span>
							<span v-if="fmitm.progress_status == 0 ? true : false" class="bookState active_qj">{{fmitm.progress_status_name}}</span>
						</div>
					</div>
					<div class="totalBook">
						<p>{{itemFm.name}}</p>
						<p>共{{itemFm.list.length}}</p>
					</div>
					<img src="../../assets/img/rightarr_pink.png" alt="" class="yjjbArr02" @click.stop="toSoltDetail(12)" />
				</div>
			</div>
		</div>
		<!-- 本地导入 封面-->
		<div class="yunjin_jbBox" v-if="!showBoxFm">
			<div class="title_house">
				<div>
					<h4>本地导入</h4>
				</div>
				<!-- @click.stop="toSoltDetail(15)" -->
				<div>
					<span>全部</span>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
			</div>
			<div class="yunjin_jb">
				<!-- @click="upimg_fbjw" -->

				<swiper class="swiper" :options="hm_swiperOption">
					<swiper-slide v-if="">
						<div class="bdDaoRbook">
							<img src="../../assets/img/upimg_fbjw.png" alt="" class="imgfile">
							<input type="file" id="uploadFile" accept=".doc,.txt" class="file" @change="fileChange">
						</div>
					</swiper-slide>
					<swiper-slide v-for="(item,idx) in fileList" v-if="fileList != []">
						<!--  v-for="(item,idx) in fileList" v-if="fileList != []" -->
						<div @touchstart="gotouchstart02(idx,'本地')" @touchmove="gotouchmove02" @touchend="gotouchend02(idx,'本地')" @click="fileFn(idx)">
							<div class="bookImg">
								<img src="../../assets/img/bookName.png" alt="">
								<p style="position: absolute;top:20%;font-size: 12px;overflow: hidden;text-align: center;padding:0 10px;width:100%;box-sizing: border-box;">{{item.fileName}}</p>
							</div>
							<p class="bookName"><span v-for="(books_name,bookNameIndex) in item.fileName" v-if="bookNameIndex > 6 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div v-show="!showhot_books" class="zwsjToast">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 列表 本地导入 -->
		<div class="yunjin_jbBoxFm yunjin_jbBoxFm_two" v-if="showBoxFm">
			<div class="yunjin_jb" v-show="showcollect_listFm">
				<div v-for="(itemFm,index) in fileListFm" class="swiperFmImgFather" v-if="index == 0 ?true:false">
					<div v-for="(fmitm,fmidx) in itemFm" @click="fileFn(fmidx)" class="swiperFmImg">
						<img src="../../assets/img/bookName.png" alt="">
					</div>
				</div>
				<div class="totalBook">
					<p>本地导入</p>
					<p>共{{fileList.length}}</p>
				</div>
				<div class="bdDaoRbook">
					<img src="../../assets/img/upimg_fbjw.png" alt="" class="imgfile">
					<input type="file" id="uploadFile" accept=".doc,.txt" class="file" @change="fileChange">
				</div>
				<!-- @click.stop="toSoltDetail(15)"  -->
				<img src="../../assets/img/rightarr_pink.png" alt="" class="yjjbArr02" />
			</div>
		</div>
		<!-- 仅显示本地导入  封面 -->
		<!-- <div class="yunjin_jbBox" v-if="!allShow && onlyBdShow">
			<div class="title_house">
				<div>
					<h4>本地导入</h4>
				</div>
				<div>
					<span>全部</span>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
			</div>
			<div class="yunjin_jb">
				<swiper class="swiper" :options="hm_swiperOption">
					<swiper-slide v-if="">
						<div class="bdDaoRbook">
							<img src="../../assets/img/upimg_fbjw.png" alt="" class="imgfile">
							<input type="file" id="uploadFile" accept=".doc,.txt" class="file" @change="fileChange">
						</div>
					</swiper-slide>
					<swiper-slide v-for="(item,idx) in fileList" v-if="fileList != []">
						<div @touchstart="gotouchstart02(idx,'本地')" @touchmove="gotouchmove02" @touchend="gotouchend02(idx,'本地')" @click="fileFn(idx)">
							<div class="bookImg">
								<img src="../../assets/img/bookName.png" alt="">
								<p style="position: absolute;top:20%;font-size: 12px;overflow: hidden;text-align: center;padding:0 10px;width:100%;box-sizing: border-box;">{{item.fileName}}</p>
							</div>
							<p class="bookName"><span v-for="(books_name,bookNameIndex) in item.fileName" v-if="bookNameIndex > 6 ? false : true">{{books_name}}</span></p>
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div v-show="!showhot_books" class="zwsjToast">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div> -->


		<!-- deleShow -->
		<div class="luntantost" v-show="deleShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div @click="delBooks" class="active">删除</div>
				<div @click="jumpBookinfoToast" v-if="dele_txt == '本地' ? false : true" class="active">书本详情</div>
			</div>
		</div>
		<div class='mask' v-show="deleShow == true" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	export default {
		props: ['fmOrList', 'fmOrListFnWjData'],
		data() {
			return {
				sj_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				hm_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				collect_list: [], //最近收藏
				collect_listFm: [], //最近收藏--封面
				read_history: [], //最近阅读
				read_historyFm: [], //最近阅读--封面
				hot_books: [], //热门推荐
				dark_horse_list: [], //黑马榜
				showBox: true,
				showBoxFm: false,
				showcollect_listFm: false,
				showcollect_list: true,
				showread_history: true,
				showhot_books: true,
				showdark_horse_list: true,
				fileName: '', //本地文件名称
				fileTxt: '', //本地文件内容
				fileList: [], //本地文件列表导入项
				fileListFm: [],
				// onlyBdShow: true,
				// allShow: true,
				deleShow: false,
				clearHfId: '',
				scInfoData: [],
				lock_status: '',
				wj_show: false,
				dele_txt: '',
				// fmOrListFnWjData: [],
				fmOrListFnWj: '',
				scListShow: true,
			}
		},
		watch: {
			fmOrList(value) {
				if (value == 1) {
					this.showBoxFm = false;
					// this.onlyBdShow = true;
					// this.allShow = false;
					this.scListShow = true;
					this.showcollect_listFm = false;
				} else if (value == 2) {
					this.showBoxFm = true;
					// this.onlyBdShow = true;
					// this.allShow = false;
					this.scListShow = true;
					this.showcollect_listFm = true;
				} else if (value == 6) {
					// this.showBoxFm = false;
					// this.onlyBdShow = true;
					// this.allShow = true;
					this.scListShow = true;
					// this.showcollect_listFm = false;
				}  else if (value == 3) {
					this.scListShow = true;
					// this.showcollect_listFm = false;
				}else if (value == 9) {
					this.$router.push('/madeCategry')
				}

			},
			fmOrListFnWjData(val) {
				// 收藏筛选条件
				if(val == 3){//更新
					this.wj_show = false;
					this.bookshelfData(1);
				}else if(val == 4){//收藏
					this.wj_show = false;
					this.bookshelfData(0);
				}else if(val == 5){//阅读
					this.wj_show = false;
					this.bookshelfData(2);
				}else if(val == 7){//完结
					this.wj_show = true;
					this.scListShow = true;
					this.bookshelfData(3);
				}else{
					this.bookshelfData(1);
					this.wj_show = false;
				}
				// -----------
				if (val == 8) {
					this.scListShow = false;
				} else{
					this.scListShow = true;
				}
			}
		},
		created() {
			this.fileList = JSON.parse(localStorage.getItem('fileList')) ? JSON.parse(localStorage.getItem('fileList')) : [];
			if (JSON.parse(localStorage.getItem('fileList')) != undefined) {
				this.fmArrayFz(this.fileList, 8); //本地导入
			}
			if (localStorage.getItem('fmOrListFn') == 2) { //列表模式
				this.fmOrListFn = localStorage.getItem('fmOrListFn');
				this.showBoxFm = true;
				this.showcollect_listFm = true;
			} else if (localStorage.getItem('fmOrListFn') == 1) { //封面模式
				this.fmOrListFn = localStorage.getItem('fmOrListFn');
				this.showBoxFm = false;
				this.showcollect_listFm = false;
			} else {
				this.showBoxFm = false;
			}
			if (localStorage.getItem('fmOrListFnWj') == 7) {
				this.fmOrListFnWj = localStorage.getItem('fmOrListFnWj');
				this.wj_show = true;
			} else {
				this.wj_show = false;
			}
			if(localStorage.getItem('fmOrListFnWj') == 3){//更新
				this.bookshelfData(1);
			}else if(localStorage.getItem('fmOrListFnWj') == 4){//收藏
				this.bookshelfData(0);
			}else if(localStorage.getItem('fmOrListFnWj') == 5){//阅读
				this.bookshelfData(2);
			}else if(localStorage.getItem('fmOrListFnWj') == 7){//完结
				this.bookshelfData(3);
			}else {
				this.bookshelfData(1);
			}

		},
		methods: {
			bookshelfData(order) {
				this.$axios.post(this.$api.book_shelf,
				{
					order: order,//筛选收藏
				}).then(res => {
					// if(res)
					if (res.data.code == 20111) {
						this.showBox = false;
						Toast(res.data.msg);
					} else if (res.data.data != null) {
						// 黑马榜
						this.hot_books = res.data.data.hot_books;
            this.read_history = res.data.data.read_history;
						this.dark_horse_list = res.data.data.dark_horse_list;
						if (JSON.parse(localStorage.getItem('userInfoData')) != null) {
							if(order == 0){//收藏
								this.collect_list = res.data.data.collect_list_1;
							}else if(order == 1){ //更新时间
								this.collect_list = res.data.data.collect_list_2;
							}else if(order == 2){ //阅读
								this.collect_list = res.data.data.collect_list_3;
							}else if(order == 3){ //完结
								this.collect_list = res.data.data.collect_list_4;
							}


							this.fmArrayFz(this.collect_list, 1); //最近收藏

							this.fmArrayFz(this.read_history, 2); //最近阅读
							if (this.collect_list.length == 0) {
								this.showcollect_list = false;
							}
							if (this.read_history.length == 0) {
								this.showread_history = false;
							}
						} else {
							if (this.collect_list == '') {
								this.showcollect_list = false;
							}
							if (this.read_history == '') {
								this.showread_history = false;
							}
						}
						if (this.hot_books.length == 0) {
							this.showhot_books = false;
						}
						if (this.dark_horse_list.length == 0) {
							this.showdark_horse_list = false;
						}

					}

				})
			},
			gotouchstart01(id, books_id, lock_status, b) {
				this.clearHfId = books_id;
				this.dele_txt = b;
				this.lock_status = lock_status;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend01(id, books_id, lock_status, b) {
				this.dele_txt = b;
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove01() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			gotouchstart(id, books_id, lock_status, b) {
				this.clearHfId = books_id;
				this.dele_txt = b;
				this.lock_status = lock_status;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend(id, books_id, lock_status, b) {
				this.dele_txt = b;
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			gotouchstart02(id, b) {
				this.dele_txt = b;
				this.clearHfId = id;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend02(id, b) {
				this.dele_txt = b;
				this.clearHfId = id;
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove02() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			// 删除书单
			delBooks() {
				var _t = this;
				Dialog.confirm({
						// title: '',
						message: '删除该书',
					})
					.then(() => {
						if (this.dele_txt == '收藏') {
							this.$axios.post(this.$api.xianmian_collect, {
								books_ids: this.clearHfId
							}).then(res => {
								Toast(res.data.msg);
								this.deleShow = false;
								this.bookshelfData();
							})
						}
						if (this.dele_txt == '阅读') {
							// 最近阅读删除
							this.$axios.post(this.$api.del_history_book, {
								books_id: this.clearHfId
							}).then(res => {
								Toast(res.data.msg);
								this.deleShow = false;
								this.bookshelfData();
							})
						}
						if (this.dele_txt == '本地') {
							// 本地删除
							if (JSON.parse(localStorage.getItem('fileList')) != undefined) {
								var a = JSON.parse(localStorage.getItem('fileList'));
								a.splice(this.clearHfId, 1)
								localStorage.setItem('fileList', JSON.stringify(a))
								this.fileList = JSON.parse(localStorage.getItem('fileList')) || [];
							}

							Toast('删除成功');
							this.deleShow = false;
						}
						this.scInfoData = JSON.parse(localStorage.getItem('scRadio'));
						for (var i = 0; i < this.scInfoData.length; i++) {
							if (this.scInfoData[i].scBookID == this.clearHfId) {
								this.scInfoData.splice(i, 1);
								localStorage.setItem('scRadio', JSON.stringify(this.scInfoData))
								return this.scInfoData
							}
						}
						this.deleShow = false;
					})
					.catch(() => {
						// on cancel
					});
			},
			jumpBookinfoToast() {
				if (this.lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
				} else {
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: this.clearHfId,
							bookshelfUrl: 'bookshelfUrlsj',
						}
					})
				}
			},
			delArrayItem(arr, item) {
				for (var i = 0; i < arr.length; i++) {
					if (arr[i] == item) {
						arr.splice(i, 1);
						return arr
					}
				}
			},
			hideTost01() {
				this.deleShow = false;
			},
			readFile(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					reader.readAsText(file, "GB2312");
					reader.onload = function(e, rs) {
						this.fileTxt = resolve(e.target.result);
						console.log(this.fileTxt)
					};
				});
			},
			fmArrayFz(data, idx) {
				var result = [];
				var data = data;
				var chunk = 4; //每4个分一组
				for (var i = 0, j = data.length; i < j; i += chunk) {
					result.push(data.slice(i, i + chunk));
				}
				if (idx == 1) {

					this.collect_listFm = result; //封面数组组装
					console.log(this.collect_listFm)
				} else if (idx == 2) {
					this.read_historyFm = result; //封面数组组装
				} else if (idx == 3) {
					this.fileListFm = result;
				}

			},
			fileChange() {
				let file = document.getElementById("uploadFile").files[0];
				console.log(file.name, 'file')
				this.fileName = file.name;
				let vm = this;
				this.readFile(file).then(res => {
					// let arr = res.split(/[\n]/);
					// arr.forEach((item, index) => {
					// 	console.log(item,'0-===============')
					// });
					this.fileTxt = res;
					this.fileList.push({
						fileName: this.fileName,
						fileTxt: this.fileTxt,
					})
					this.fmArrayFz(this.fileList, 3); //最近收藏
					console.log(this.fileList, 'this.fileList');
					localStorage.setItem('fileList', JSON.stringify(this.fileList));
					// window.reload()
				});
			},
			fileFn(idx) {
				console.log(idx, 'idx')
				if (idx != undefined) {
					this.$router.push({
						path: '/readbook',
						query: {
							fileIdx: idx
						}
					});
				}

			},
			//跳转排行子页面
			toSoltDetail(i) {
				if (localStorage.getItem('fmOrListFn') == undefined) {
					localStorage.setItem('fmOrListFn', 1);
					this.$router.push({
						path: '/soltPhDetail',
						query: {
							index: i,
							bookshelfUrl: 'bookshelfUrl',
							com_name: 'home',
						}
					})
				} else {
					this.$router.push({
						path: '/soltPhDetail',
						query: {
							index: i,
							bookshelfUrl: 'bookshelfUrl',
							com_name: 'home',
						}
					})
				}

			},
			// 跳转详情页
			jumpBookinfo(val, lock_status) {
				if (lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
				} else {
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: val,
							bookshelfUrl: 'bookshelfUrlsj',
						}
					})
				}
			},
			jumpReadBook(val, lock_status) {
				if (lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
				} else {
					if (val.books_id != undefined) {
						this.$router.push({
							path: '/readbook',
							query: {
								readId: val.chapter_id || '',
								books_id: val.books_id,
								readNum: val.number,
								chapter_num: this.$route.query.chapter_num,
								chapter_id: this.$route.query.chapter_id,
							}
						})
					}

				}
			},
			upimg_fbjw() {
				Toast('该功能尚未开通')
			},
		}
	}
</script>

<style scoped lang="less">
	.bookshelfIndexBox {
		width: 100vw;
		height: 100%;
		overflow-x: hidden;
		overflow-y: scroll;
	}

	// 云锦金榜
	.yunjin_jbBox {
		height: 430px;
		background-color: #fff;
		border-bottom: 10px solid #f0f0f0;
		padding: 20px 16px;
		color: #000;

		.title_house {
			display: flex;
			justify-content: space-between;
			line-height: 80px;
			font-size: 28px;
			/*px*/
			color: #ff4081;
			position: relative;

			h4 {
				font-size: 30px;
				/*px*/
				color: #000;
			}

			span {
				padding-right: 40px;
			}

			img {
				position: absolute;
				right: 0px;
				top: 50%;
				transform: translateY(-50%);
				width: 50px;
			}
		}

		.zwsjToast {
			text-align: center;

			img {
				width: 160px;
			}
		}

		.yunjin_jb {
			margin-top: 10px;
			height: 340px !important;
			overflow: hidden;
			position: relative;
			box-sizing: border-box;

			.bdDaoRbook {
				position: relative;
				height: 220px;
				width: 175px;

				.imgfile {
					position: absolute;
					top: 0;
					left: 0;
					height: 220px;
					width: 155px;
					-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
				}

				.file {
					position: absolute;
					top: 0;
					left: 0;
					height: 220px;
					width: 175px;
					opacity: 0;
				}
			}

			.swiper-container {
				height: 370px;

				.swiper-slide {
					width: 28% !important;
					margin-right: 15px !important;

					div {
						text-align: center;

						img {
							width: 190px;
							height: 270px;
							/*px*/
							vertical-align: middle;
							-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
						}
					}

					.bookImg {
						position: relative;

						.bookState {
							position: absolute;
							top: 10px;
							right: 6%;
							// border-top-left-radius: 30px;
							// border-bottom-left-radius: 30px;
							padding-left: 15px;
							padding-right: 10px;
							font-size: 22px;
							/*px*/
							color: #fff;
						}

						// 更新
						.active_updata {
							background: url(../../assets/img/bookshelf_absImg01.png) no-repeat;
							background-size: 100% 100%;
						}

						//请假
						.active_qj {
							background: url(../../assets/img/bookshelf_absImg02.png) no-repeat;
							background-size: 100% 100%;
						}

						//完结
						.active_wj {
							background: url(../../assets/img/bookshelf_absImg03.png) no-repeat;
							background-size: 100% 100%;
						}
					}

					.bookName {
						font-size: 30px;
						/*px*/
						overflow: hidden;
						white-space: nowrap;
						// text-overflow: ellipsis;
						padding-top: 20px;
						color: #000;
						text-align: center;
					}

					.jianjie {
						font-size: 24px;
						/*px*/
						color: #000;
						opacity: 0.6;
						padding-top: 15px;
					}
				}
			}
		}
	}

	// 封面列表
	.yunjin_jbBoxFm {
		height: 300px;
		background-color: #fff;
		border-bottom: 10px solid #f0f0f0;
		padding: 20px 16px;

		.yunjin_jb {
			margin-top: 10px;
			height: 280px !important;
			overflow: hidden;
			position: relative;

			.yjjbArr02 {
				position: absolute;
				right: 0px;
				top: 50%;
				transform: translateY(-50%);
				width: 80px;
			}

			.totalBook {
				position: absolute;
				left: 260px;
				top: 50%;
				transform: translateY(-50%);
				width: 155px;

				p {
					line-height: 60px;
					font-size: 30px;
					/*px*/
					color: #000;
				}

				p:last-child {
					font-size: 28px;
					/*px*/
					color: rgba(0, 0, 0, .5);
				}
			}

			.bdDaoRbook {
				position: absolute;
				top: 50%;
				right: 10%;
				transform: translateY(-50%);

				.imgfile {
					position: absolute;
					top: 50%;
					right: 10%;
					width: 155px;
					transform: translateY(-50%);
					-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
					box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
					/*no*/
				}

				.file {
					position: absolute;
					top: 50%;
					right: 10%;
					height: 220px;
					width: 175px;
					opacity: 0;
					transform: translateY(-50%);
				}
			}

			.swiperFmImgFather {
				width: 24% !important;
				margin-right: 8px !important;
				background-color: rgba(0, 0, 0, .1);
				height: 240px;
				padding: 20px;
				border-radius: 20px;
				overflow: hidden;

				.swiperFmImg {
					display: inline-block;
					position: relative;

					img {
						width: 79px;
						height: 110px;
						/*px*/
						display: inline-block;
						margin-right: 7px;
						margin-bottom: 5px;
						vertical-align: middle;
						-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
					}

					.bookState {
						position: absolute;
						top: 10px;
						right: 0;
						// border-top-left-radius: 30px;
						// border-bottom-left-radius: 30px;
						padding-left: 15px;
						padding-right: 10px;
						font-size: 20px;
						/*px*/
						color: #fff;
						height: 40px;
						overflow: hidden;
					}

					// 更新
					.active_updata {
						background: url(../../assets/img/bookshelf_absImg01.png) no-repeat;
						background-size: 80% 80%;
					}

					//请假
					.active_qj {
						background: url(../../assets/img/bookshelf_absImg02.png) no-repeat;
						background-size: 80% 80%;
					}

					//完结
					.active_wj {
						background: url(../../assets/img/bookshelf_absImg03.png) no-repeat;
						background-size: 80% 80%;
					}
				}

				.swiperFmImg:nth-child(2n) img {
					margin-right: 0px;
					margin-left: 7px;
				}

				.swiperFmImg:nth-child(3) img {
					margin-bottom: 0px;
					margin-top: 5px;
				}

				.swiperFmImg:nth-child(4) img {
					margin-bottom: 0px;
					margin-top: 5px;
				}
			}
		}
	}

	.yunjin_jbBoxFm_two {
		padding: 20px 16px 50px;
	}

	//弹窗
	.luntantost {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		// height: 454px;
		background: url(../../assets/img/pltost.png) no-repeat;
		background-size: 100%;
		z-index: 120;

		img {
			position: absolute;
			bottom: 40px;
			left: 0;
			width: 100%;
		}

		.luntantostbgc {
			margin-top: 124px;
			z-index: 10000 !important;
			background: url(../../assets/img/dog.png) no-repeat #fff;
			background-size: 114% 88%;
			background-position: 0px 50%;

			div {
				line-height: 120px;
				text-align: center;
				color: #737373;
				font-size: 30px;
				/*px*/
				z-index: 1000 !important;
			}

			div.active {
				color: #ff4081;
			}

		}

	}

	.mask {
		position: fixed;
		bottom: 0px;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .3);
		z-index: 100;
	}
</style>
